/**
 ******************************************************************************
 * @file    AppService.js
 * @brief   This file is the common place to send AJAX calls.
 ******************************************************************************
 */

import i18n from '../i18n';
import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

i18n.loadNamespaces('Core');

export default class UserPermissions {
	static async getAllPermissions() {
		return await ApiService.GetData(`${API_URLS.PERMISSIONS_USERTYPES}`, 'accounts');
	}

	static async updatePermissions(id, requestBody) {
		return await ApiService.PatchData(`${API_URLS.UPDATE_PERMISSIONS}/${id}`, requestBody, 'accounts');
	}

	static async getCurrentPermissions() {
		return await ApiService.GetData(`${API_URLS.CURRENT_ACTIVE_PERMISSIONS}`, 'accounts');
	}
}
